import type { WriteMap } from "./character-edits.js";

export interface PackRef {
  id: string;
  version: string;
  source: "public" | "guild" | "user";
  snapshot: string;
}

export function installRulesetPack(tablePath: string, ref: PackRef): WriteMap {
  return {
    [`${tablePath}/meta/rulesetPackRef`]: {
      id: ref.id,
      version: ref.version,
      source: ref.source,
      snapshot: ref.snapshot,
    },
  };
}

export function installScenePack(tablePath: string, ref: PackRef): WriteMap {
  return {
    [`${tablePath}/meta/scenePackRefs/${ref.id}`]: {
      version: ref.version,
      source: ref.source,
      snapshot: ref.snapshot,
    },
  };
}

export function uninstallScenePack(tablePath: string, packId: string): WriteMap {
  return { [`${tablePath}/meta/scenePackRefs/${packId}`]: null };
}
